import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "d-flex flex-column flex-grow-1" };
const _hoisted_2 = { class: "title-input" };
const _hoisted_3 = ["type", "placeholder", "dir"];
const _hoisted_4 = {
    key: 0,
    class: "d-flex justify-content-end length-input mt-1"
};
import { ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Input',
    props: {
        modelValue: { type: [String, Number] },
        title: { type: String },
        maxNumber: { type: Number },
        language: { type: String },
        placeholder: { type: String },
        type: { type: String },
        isRtl: { type: Boolean, default: false }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const content = ref(props.modelValue);
        function onInput(e) {
            const input = e.target;
            const max = props.maxNumber;
            if (input.value.length > max) {
                input.value = input.value.slice(0, max);
            }
            content.value = input.value;
            emit('update:modelValue', content.value);
        }
        watch(() => props.modelValue, val => content.value = val);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1),
                _withDirectives(_createElementVNode("input", {
                    class: "w-100 main-input mt-1",
                    type: __props.type === 'number' ? 'number' : 'text',
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((content).value = $event)),
                    placeholder: props.placeholder,
                    onInput: onInput,
                    dir: __props.isRtl ? 'rtl' : 'ltr'
                }, null, 40, _hoisted_3), [
                    [_vModelDynamic, content.value]
                ]),
                (__props.maxNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(content.value?.toString().length) + "   /   " + _toDisplayString(props.maxNumber), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
